import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardStore } from '@lib/store';
import { CardStatus } from '@shared/api/rest/cards';
import { Button, Modal, Text } from '@shared/widgets';

interface BlockCardModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BlockCardModal = (props: BlockCardModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { t } = useTranslation('card');

  const blocked = useMemo(
    () => cardStore.data?.status === CardStatus.FROZEN || cardStore.data?.status === CardStatus.BLOCKED,
    [cardStore.data?.status],
  );
  const saveHandler = async () => {
    if (blocked) await $cardStore.events.unfreezeCard(cardStore.data!.cardId);
    else await $cardStore.events.freezeCard(cardStore.data!.cardId);
    props.onClose();
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      loading={cardStore.actionLoading}
      title={t('sidebar.modals.blockCard.title', { action: t(`sidebar.modals.blockCard.${blocked ? 'unfreeze' : 'freeze'}`) })}
    >
      <Text weight='medium'>
        {t('sidebar.modals.blockCard.description', {
          action: t(`sidebar.modals.blockCard.${blocked ? 'unfreeze' : 'freeze'}`).toLowerCase(),
        })}
      </Text>
      <div className='mt-6'>
        <div className='flex gap-6'>
          <Button color='outlined' fullWidth onClick={props.onClose}>
            {t('buttons.close', { ns: 'common' })}
          </Button>
          <Button color='primary' fullWidth onClick={saveHandler}>
            {t(`sidebar.modals.blockCard.buttons.${blocked ? 'unfreeze' : 'freeze'}`)}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
